/* MR_AI_FRONTEND_DISABLED_R48 */
(function(){
  "use strict";
  window.__MR_AI_FRONTEND_DISABLED__ = true;

  function ensureOffStyle(){
    if(document.getElementById("mr-ai-r48-off-style")) return;
    var style=document.createElement("style");
    style.id="mr-ai-r48-off-style";
    style.textContent=[
      "#ng-netguard-chatbot",
      ".ng-chatbot-toggle",
      "#mr-ai-r39-primary-launcher",
      "#mr-ai-r36-rescue-launcher",
      "[data-mr-ai-r44-native-launcher]",
      "[data-mr-ai-r42-native-launcher]",
      "[data-mr-ai-r39-onscreen]"
    ].join(",")+"{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important}";
    (document.head||document.documentElement).appendChild(style);
  }

  function hideMrAi(){
    ensureOffStyle();
    var selectors=[
      "#ng-netguard-chatbot",
      ".ng-chatbot-toggle",
      "#mr-ai-r39-primary-launcher",
      "#mr-ai-r36-rescue-launcher"
    ];
    selectors.forEach(function(selector){
      document.querySelectorAll(selector).forEach(function(node){
        try{
          node.style.setProperty("display","none","important");
          node.style.setProperty("visibility","hidden","important");
          node.style.setProperty("opacity","0","important");
          node.style.setProperty("pointer-events","none","important");
          node.setAttribute("aria-hidden","true");
        }catch(_){}
      });
    });
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",hideMrAi,{once:true});
  }else{
    hideMrAi();
  }

  try{
    new MutationObserver(hideMrAi).observe(document.documentElement,{childList:true,subtree:true});
  }catch(_){}
  setTimeout(hideMrAi,100);
  setTimeout(hideMrAi,1000);
  setTimeout(hideMrAi,3000);
})();